<div
  (click)="isOpen = !isOpen"
  type="button"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  <svg-icon
    src="icons/info.svg"
    class="relative"
    [ngClass]="isOpen ? 'fill-bo-primary' : 'fill-bo-secondary'"
  />
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
>
  <div
    class="absolute -top-[40px] left-[32px] flex h-[80px] w-[320px] overflow-hidden rounded-lg bg-bo-black/70 px-3 py-2 text-bo-white shadow-md backdrop-blur-md"
  >
    <div
      class="bo-secondary relative flex items-center justify-center !text-bo-white"
    >
      <div class="absolute right-0 top-0">✕</div>
      <div class="overflow-hidden">
        <div class="font-bold">{{ title() }}</div>
        <div>{{ text() }}</div>
      </div>
    </div>
  </div>
</ng-template>
